import * as swcHelpers from '@swc/helpers';
import { format } from 'date-fns';
import { takeLatest, put } from 'redux-saga/effects';
import { DataLayer } from '@grandvisionhq/analytics';
import { ORDER_DETAILS_VIEW, TRACE_ORDER, ORDER_ITEM_SELECT, ORDER_REORDER } from '../actions.js';
import { clearEvents } from '../utils.js';

function* onOrderDetailsView(action) {
    const { orderId , orderDate , paymentStatus , shippingStatus  } = action.payload;
    if (!orderId || !orderDate) {
        throw new Error('Can not construct a meaningful event');
    }
    const data = makeOrderEvent('order details', 'view', orderId, orderDate, paymentStatus, shippingStatus);
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function* onTraceOrder(action) {
    const { orderId , orderDate , paymentStatus , shippingStatus  } = action.payload;
    if (!orderId || !orderDate) {
        throw new Error('Can not construct a meaningful event');
    }
    const data = makeOrderEvent('product list', 'follow order', orderId, orderDate, paymentStatus, shippingStatus);
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function* onOrderItemSelect(action) {
    const { select , orderId , orderDate , paymentStatus , shippingStatus  } = action.payload;
    if (!orderId || !orderDate) {
        throw new Error('Can not construct a meaningful event');
    }
    const data = makeOrderEvent('product list', select ? 'select' : 'unselect', orderId, orderDate, paymentStatus, shippingStatus);
    yield put(clearEvents());
    yield put(DataLayer.Actions.pushEvent(data));
}
function* onReorder(action) {
    const { currencyCode , id , lineItems  } = action.payload;
    if (!currencyCode || !id || !lineItems || lineItems.length === 0) {
        throw new Error('Can not construct a meaningful event');
    }
    yield put(DataLayer.Actions.pushEvent({
        atfEcommerce: null
    }));
    const data = makeReorderEvent(currencyCode, id, lineItems);
    yield put(DataLayer.Actions.pushEvent(data));
}
function makeReorderEvent(currencyCode, id, lineItems, prescriptionGlassesLineItems) {
    const products = DataLayer.DataLayerUtils.mapLineItemToDataLayerProductObjects(lineItems, prescriptionGlassesLineItems).map((product)=>swcHelpers.objectSpread({}, product, {
            dimension150: 'reorder: partial',
            dimension140: product ? product.id : 'n/a'
        })
    );
    return {
        event: 'gvAddToCart',
        atfEcommerce: {
            ecommerce: {
                currencyCode,
                cart: {
                    id
                },
                add: {
                    products
                }
            }
        }
    };
}
function makeOrderEvent(block, interaction, orderId, orderDate, paymentStatus, shippingStatus) {
    return {
        event: 'myAccount',
        events: {
            category: 'my orders',
            action: {
                block,
                interaction,
                orderId,
                orderDate: `${format(orderDate, `ddMMyyyy`)}`,
                paymentStatus: paymentStatus || 'n/a',
                shippingStatus: shippingStatus || 'n/a'
            }
        }
    };
}
/**
 * Main export
 */ var OrderSagas = [
    takeLatest(ORDER_DETAILS_VIEW, onOrderDetailsView),
    takeLatest(TRACE_ORDER, onTraceOrder),
    takeLatest(ORDER_ITEM_SELECT, onOrderItemSelect),
    takeLatest(ORDER_REORDER, onReorder), 
];

export { OrderSagas as default, onOrderDetailsView, onOrderItemSelect, onReorder, onTraceOrder };
//# sourceMappingURL=orders.js.map
